import Spline from "@splinetool/react-spline";

export default function WelcomeScreen() {
  return (
    <div style={{ margin: "0 auto" }}>
      <Spline scene="https://prod.spline.design/6Wq1Q7YGyM-iab9i/scene.splinecode" />
    </div>
  );
}
